
(function () {
  var DAY_MS = 24 * 60 * 60 * 1000;

  function pad2(n) { return String(n).padStart(2, '0'); }
  function localISO(date) {
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
  }
  function parseISO(str) {
    if (!str) return null;
    var m = String(str).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  function hashString(str) {
    var h = 2166136261;
    str = String(str || '');
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  function dailyIncrement(seed, dayIndex) {
    var h = hashString(seed + '|' + dayIndex);
    return 1 + (h % 10);
  }
  function computeCount(base, startDate, seed) {
    var start = parseISO(startDate);
    var count = parseInt(base, 10);
    if (!isFinite(count)) count = 1;
    if (!start) return count;
    var today = parseISO(localISO(new Date()));
    var days = Math.floor((today - start) / DAY_MS);
    if (days <= 0) return count;
    for (var i = 0; i < days; i++) count += dailyIncrement(seed, i);
    return count;
  }
  function setCountSpan(el, source, includeParens) {
    if (!el) return;
    var host = source || el;
    var base = host.getAttribute('data-hp-revie-count-base');
    var startDate = host.getAttribute('data-hp-revie-start-date');
    var seed = host.getAttribute('data-hp-revie-seed') || 'hp';
    var count = computeCount(base, startDate, seed);
    el.textContent = includeParens === false ? String(count) : '(' + count + ')';
    el.style.visibility = 'visible';
  }
  function replaceCountInNode(root, count) {
    if (!root) return false;
    var replaced = false;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (replaced) return;
      var value = node.nodeValue || '';
      if (/\(\s*\d+\s*\)/.test(value)) {
        node.nodeValue = value.replace(/\(\s*\d+\s*\)/, '(' + count + ')');
        replaced = true;
      } else if (/\b\d+\s+reseñas\b/i.test(value)) {
        node.nodeValue = value.replace(/\b\d+\s+reseñas\b/i, count + ' reseñas');
        replaced = true;
      } else if (/\b\d+\s+reviews\b/i.test(value)) {
        node.nodeValue = value.replace(/\b\d+\s+reviews\b/i, count + ' reviews');
        replaced = true;
      }
    });
    return replaced;
  }
  function textOf(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }
  function showFallback(wrapper) {
    var original = wrapper.querySelector('[data-hp-revie-original]');
    var fallback = wrapper.querySelector('[data-hp-revie-fallback]');
    var countSpan = wrapper.querySelector('[data-hp-revie-count]');
    setCountSpan(countSpan, wrapper);
    wrapper.classList.add('hp-revie-fallback-active');
    wrapper.style.paddingTop = '10px';
    if (original) original.style.display = 'none';
    if (fallback) {
      fallback.hidden = false;
      fallback.setAttribute('aria-hidden', 'false');
      fallback.style.display = 'inline-flex';
    }
  }
  function showOriginal(wrapper) {
    var original = wrapper.querySelector('[data-hp-revie-original]');
    var fallback = wrapper.querySelector('[data-hp-revie-fallback]');
    wrapper.classList.remove('hp-revie-fallback-active');
    wrapper.style.paddingTop = '';
    if (fallback) {
      fallback.hidden = true;
      fallback.setAttribute('aria-hidden', 'true');
      fallback.style.display = 'none';
    }
    if (original) {
      original.style.display = '';
      original.style.visibility = 'visible';
    }
  }
  function processProductWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.hpRevieBound === 'true') return;
    wrapper.dataset.hpRevieBound = 'true';

    var original = wrapper.querySelector('[data-hp-revie-original]');
    var countSpan = wrapper.querySelector('[data-hp-revie-count]');
    var seed = wrapper.getAttribute('data-hp-revie-seed') || 'hp';
    var base = wrapper.getAttribute('data-hp-revie-count-base');
    var startDate = wrapper.getAttribute('data-hp-revie-start-date');
    var dynamicCount = computeCount(base, startDate, seed);
    if (countSpan) {
      setCountSpan(countSpan, wrapper);
    }

    var hasNativeReviews = wrapper.getAttribute('data-hp-has-native-reviews') === 'true';
    var started = Date.now();
    var maxWait = hasNativeReviews ? 5000 : 2500;

    function evaluate() {
      var txt = textOf(original);
      if (/\b0\s+reseñas\b/i.test(txt) || /\b0\s+reviews\b/i.test(txt) || /\bsin reseñas\b/i.test(txt)) {
        showFallback(wrapper);
        return true;
      }
      if (replaceCountInNode(original, dynamicCount)) {
        showOriginal(wrapper);
        return true;
      }
      if (!hasNativeReviews && (Date.now() - started) > maxWait) {
        showFallback(wrapper);
        return true;
      }
      if (hasNativeReviews && (Date.now() - started) > maxWait && txt.length > 0) {
        showOriginal(wrapper);
        return true;
      }
      return false;
    }

    if (evaluate()) return;

    var observer = new MutationObserver(function () {
      if (evaluate()) observer.disconnect();
    });
    if (original) observer.observe(original, { childList: true, subtree: true, characterData: true });

    var interval = setInterval(function () {
      if (evaluate()) {
        clearInterval(interval);
        observer.disconnect();
      }
      if ((Date.now() - started) > (maxWait + 2500)) {
        clearInterval(interval);
        observer.disconnect();
        if (!hasNativeReviews) showFallback(wrapper);
        else showOriginal(wrapper);
      }
    }, 250);
  }
  function initCollectionCounts(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-hp-revie-count]').forEach(function (el) {
      if (el.closest('[data-hp-revie-product]')) return;
      setCountSpan(el);
    });
  }
  function initProduct() {
    document.querySelectorAll('[data-hp-revie-product]').forEach(processProductWrapper);
  }
  function initAll(root) {
    initCollectionCounts(root);
    initProduct();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        initAll(node);
      });
    });
  });
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
